export interface DocItem {
  slug: string;
  title: string;
  blurb: string;
  group: 'overview' | 'backend' | 'frontend' | 'infra' | 'meta';
}

export const DOC_GROUPS: Array<{ key: DocItem['group']; label: string }> = [
  { key: 'overview', label: 'overview' },
  { key: 'backend', label: 'backend' },
  { key: 'frontend', label: 'frontend' },
  { key: 'infra', label: 'infra' },
  { key: 'meta', label: 'meta' },
];

export const DOCS: DocItem[] = [
  {
    slug: 'index',
    title: 'Sherlock',
    blurb: 'What Sherlock is, who it is for, what it does',
    group: 'overview',
  },
  {
    slug: 'architecture',
    title: 'Architecture',
    blurb: 'The big-picture map: FastAPI · Cloud Run · Postgres · Vertex',
    group: 'overview',
  },
  {
    slug: 'agentic-loop',
    title: 'Agentic loop',
    blurb: '/investigate end-to-end · the most interesting flow',
    group: 'backend',
  },
  {
    slug: 'sentry-rca',
    title: 'Sentry RCA',
    blurb: '/issues pipeline · the analysis cache key',
    group: 'backend',
  },
  {
    slug: 'memory',
    title: 'Memory',
    blurb: 'Feedback · episodic · reflection · procedural rules · /memory page',
    group: 'backend',
  },
  {
    slug: 'mcp-server',
    title: 'MCP server',
    blurb: 'Inbound MCP at /mcp/sse · 7 tools · 2 auth shapes',
    group: 'backend',
  },
  {
    slug: 'llm-backends',
    title: 'LLM backends',
    blurb: 'Vertex · Agent SDK · recorded · one Protocol',
    group: 'backend',
  },
  {
    slug: 'auth-security',
    title: 'Auth & security',
    blurb: 'OIDC · JWT · PAT · share-token',
    group: 'backend',
  },
  {
    slug: 'async-scheduling',
    title: 'Async & scheduling',
    blurb: 'Cloud Tasks + Cloud Scheduler · APScheduler in dev',
    group: 'backend',
  },
  {
    slug: 'integrations',
    title: 'Integrations',
    blurb: '15 tools across Sentry · Datadog · GitHub · memory',
    group: 'backend',
  },
  {
    slug: 'frontend',
    title: 'Frontend',
    blurb: 'Vite · React · MUI · ApiHelper · SSE consumer',
    group: 'frontend',
  },
  {
    slug: 'infrastructure',
    title: 'Infrastructure',
    blurb: 'Cloud Run · Cloud SQL · Firebase · Cloud Build',
    group: 'infra',
  },
  {
    slug: 'agent-teams',
    title: 'Agent teams',
    blurb: 'How Sherlock itself is built — worktrees, contracts, gates',
    group: 'meta',
  },
];

export function docIndex(slug: string): number {
  return DOCS.findIndex((d) => d.slug === slug);
}

export function neighbouring(slug: string): { prev: DocItem | null; next: DocItem | null } {
  const i = docIndex(slug);
  if (i === -1) return { prev: null, next: null };
  return {
    prev: i > 0 ? (DOCS[i - 1] ?? null) : null,
    next: i < DOCS.length - 1 ? (DOCS[i + 1] ?? null) : null,
  };
}
